<template>
  <div>
    <a
      href="https://forms.gle/u24PLKWupFxzd7Cd8"
      target="_blank"
      class="rounded-lg h-28 py-4 text-white flex flex-col text-center items-center justify-center px-12 transition hover:brightness-105 cursor-pointer pattern umami--click--t2c-plus dark:ring-violet-300 dark:ring-offset-0 ring-2 ring-offset-4"
    >
      <h1 class="text-2xl font-medium">
        t2c.app
        <span class="uppercase bg-yellow-400 text-white p-1 font-bold text-base rounded-lg">PLUS</span
        >
      </h1>
      <p class="mt-2 text-sm">
        Soutiens t2c.app et débloque de nouvelles fonctionnalités !
      </p>
    </a>
  </div>
</template>

<style type="text/css">
.pattern {
  background-image: url("/images/pattern.png"),
    -webkit-linear-gradient(60deg, rgb(76, 48, 232) 0%, rgb(108, 94, 245) 100%);
  background-size: 100px, cover;
}
</style>

<script type="text/javascript">
export default {
  name: "Plus"
};
</script>
